import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogueBloc } from '@kp/dialogue/dialogue.bloc';
import { DataStoreService } from '@kservice';
import { UserType } from '@ktypes/enums';

@Component({
  selector: 'kp-dialogue-signup',
  template: '',
})
export class DialogueSignupComponent implements OnInit {
  constructor(
    private _dataStoreService: DataStoreService,
    private _dialogueBloc: DialogueBloc,
    private _router: Router
  ) {}

  ngOnInit(): void {
    // NOTE: using a component to do redirect as guard would not be triggered
    // when the dialogue block is updated as no navigation takes place
    if (this._dataStoreService.user?.type !== UserType.user) {
      // if userType is not user yet, go Sign Up
      void this._router.navigate(['/welcome/ready']);
    } else {
      // otherwise, finish the block and move on
      this._dialogueBloc.updateBlockStatus(null, null, {});
    }
  }
}
